/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectorRef, Component, Inject, Input, OnInit} from '@angular/core';
import * as _ from 'lodash';

import template from './creative-preview-view.component.html';
import {collateCreativePreviewLineItemData} from './preview-request-data';
import {CreativePreviewResource} from '../../../components/api/resources/resource/creative-preview.resource';
import {deferMarkForCheck} from '../../common/util/defer-mark-for-check';

@Component({
  standalone: false,
  selector: 'adn-creative-preview-via-id',
  template
})
export class CreativePreviewViaIdComponent implements OnInit {
  @Input() creative: any;
  @Input() creativePreviewTrigger: any;
  @Input() maxWidth: string;
  @Input() maxHeight: string;

  previewTrigger: any = {};
  resolved = false;
  layoutType: string;

  constructor(
    @Inject(CreativePreviewResource) private readonly CreativePreview: any,
    private readonly cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {
    this.runPreview(this);

    if (this.creativePreviewTrigger) {
      this.creativePreviewTrigger.previewCreative = (previewData: any) => {
        this.runPreview(previewData);
      };
    }
  }

  private runPreview(params: any): void {
    const creative = params.creative || this.creative;
    if (!creative || !creative.id ||
      _.find(creative.validationWarnings, ['preventsAdServing', true]) ||
      !creative.layout) {
      this.resolved = true;
      return;
    }

    this.layoutType = _.get(creative, ['layout', 'detectedCategory']);
    const apiPreviewData: any = {
      creativeId: creative.id,
      creativeWidth: creative.width,
      creativeHeight: creative.height
    };
    _.assign(apiPreviewData, collateCreativePreviewLineItemData(creative));

    Promise.all([this.CreativePreview.get({id: creative.id}).$promise]).then((data: any[]) => {
      const html = data[0].html;
      const previewPayload = {
        pageTitle: 'Full-Screen Creative View',
        creativeContent: html,
        creativeWidth: creative.width || creative.height || 300,
        creativeHeight: creative.height || creative.width || 300,
        dimensionType: creative.dimensionType,
        maxWidth: this.maxWidth,
        maxHeight: this.maxHeight,
        center: false
      };

      deferMarkForCheck(this.cdr, () => {
        this.previewTrigger.previewInline?.(previewPayload, apiPreviewData);
        this.resolved = true;
      });
    });
  }
}
